
import { httpClient } from '@/app/shared/services/http-client/http-client.js';
import { appLocalStorage } from '@/app/shared/commonURLs.js';

import Loader from '@/app/shared/layouts/components/loader/loader.vue';

export default {
    name: "viewer",
    props: [
        'reportRequest',
        'parameterSent'
    ],
    data() {
        return {
            reportUrl: '',
            isLoading: true
        }
    },
    created: function () {
        
        const getReportDetailsService = appLocalStorage.SecurityServiceUrl + "Report/GetReportDetails";
        const optionsGetReportDetailsService = {
            url: getReportDetailsService,
            method: 'GET',
            params: {
                reportId: this.reportRequest.ReportId
            },
            withCredentials: true,
            crossDomain: true,
        };
        httpClient(optionsGetReportDetailsService).then(response => {
            const result = response.data;
            let ReportRequestParameters = [];
            let SentPatameters = [];
            SentPatameters = this.reportRequest.ReportRequestParameters;
            ReportRequestParameters = result.ReportParameterList;
            if (this.parameterSent) {
                const reportParametersLength = ReportRequestParameters.length;

                for (let param = 0; param < SentPatameters.length; param++) {

                    for (var i = 0; i < reportParametersLength; i++) {
                        if (ReportRequestParameters[i].ReportParameterName == SentPatameters[param].ReportParameterName) {
                            ReportRequestParameters[i].ParameterValue = SentPatameters[param].ParameterValue;
                        }
                    }
                }
            }
            const ReportRequest = {
                ReportRequestId: 2,
                ReportId: parseInt(this.reportRequest.ReportId),
                ReportPath: result.ReportUrl,
                UniqueId: null,
                HidePrint: result.HidePrint,
                HideExport: result.HideExport,
                PageSize: result.PageSize,
                ReportRequestParameters: ReportRequestParameters,// this.parameterSent ? this.reportRequest.ReportRequestParameters : result.ReportParameterList ,
            };
            const url = localStorage['MedicalBase'] + 'Ui.Utilities/ReportViewers/vwSSRS.aspx/CreateReportRequest';
            const options = {
                url: url,
                method: 'POST',
                data: ReportRequest,
                withCredentials: true,
                crossDomain: true,
            };
            httpClient(options).then(response => {
                this.reportUrl = localStorage['MedicalBase']  + "Ui.Utilities/ReportViewers/vwSSRS.aspx?ReportRequestID=" + response.data.d;
                this.isLoading = false;
            });
           
        });


    },
    methods: {

    },
    components: {
        Loader
    },
}